export const LOCALSTORAGE_CURRENT_DOMAIN = 'currentDomain';
